import React from 'react';

const Loading = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#00053E',
      color: '#FFC72C',
    }}>
      <div style={{
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '10px',
      }}>
        Loading...
      </div>
      <div style={{
        fontSize: '16px',
        color: '#C69214',
      }}>
        Please wait while we get things ready.
      </div>
    </div>
  );
};

export default Loading;